import { useFastLane } from '../store/index';
import { useMemo } from 'react';

export default function BackgroundImageFullGrid() {
    return (
        <Background />
    );
}

function Background() {
    const theme = useFastLane(f => f.getTheme());
    const fastLaneStyle = useFastLane(f => f.style);
    const brightness = useMemo(() => {
        const params = new URLSearchParams(window.location.search);
        return parseFloat(params.get('brightness') || '1');
    }, []);

    return (
        <div
            style={{
                position: 'absolute',
                left: '0',
                top: theme?.gridOffset?.horizontal ?? 0,
                // top: 0,
                height: '100%',
                width: '100%',
                zIndex: 2,
                backgroundImage: `url(${fastLaneStyle?.background?.url})`,
                backgroundRepeat: 'repeat-x',
                backgroundPosition: 'center',
                backgroundSize: 'auto 100%',
                filter: `brightness(${brightness})`,
            }}
        />
    );
}
